<!-- app-routing.module.ts Components should have Breadcrumbs at the top -->
<nav class="breadcrumbs">
  <ul class="pagination">
    <li class="dark"><a routerLink="/">{{ dashboardService.client.name }}</a></li>
    <li class="disabled"><a routerLink="/website">Website</a></li>
  </ul>
  <a routerLink="/website/settings"><i class="large glyphicon glyphicon-cog"></i></a>
  <br />
  <a class="underline reverse" *ngIf="dashboardService.website" target="_blank" href="{{ '//' + dashboardService.website.domain }}">
    {{ dashboardService.website.domain }}
  </a>
</nav>

<div class="container-fluid">
  <div class="row">
    <div class="col-md-6">
      <div *ngIf="dashboardService.website" class="panel panel-default">
        <div class="panel-heading">
          <h3 class="panel-title">
            Text Message History
            <!--//jeb we could put their FROM number somewhere? -->
          </h3>
        </div>
        <div *ngIf="dashboardService.website" class="panel-body center">
          <div class="container-fluid table">
            <div class="header row">
              <div class="col-xs-4">Sent Date</div>
              <div class="col-xs-4">Message</div>
              <div class="col-xs-2">To</div>
              <div *ngIf="user.isEmployee" class="col-xs-2 red">Price</div><!--//jeb not enuf rows now?? totally new table? -->
            </div>
            <div class="row red bold underline" *ngIf="user.isEmployee">
              <div class="col-xs-4"></div>
              <div class="col-xs-4"></div>
              <div class="col-xs-2">Total:</div>
              <div class="col-xs-2">{{ textMessageTotalCost | currency }}</div>
            </div>
            <div class="row" *ngFor="let textMessage of dashboardService.website.textMessageHistory">
              <div class="col-xs-4">
                {{ textMessage.sentDate }}
                {{ textMessage.sentDate | date:'medium' }}
              </div><!--//JEB BUG, no date?!? blank-->
              <div class="col-xs-4">{{ textMessage.body }}</div>
              <div class="col-xs-2">{{ textMessage.to }}</div>
              <div *ngIf="user.isEmployee" class="col-xs-2">{{ textMessage.price }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">      
      <div *ngIf="dashboardService.website" class="panel panel-default">
        <div class="panel-heading">
          <h3 class="panel-title">
            Visit History - Coming Soon
          </h3>
        </div>
        <div *ngIf="dashboardService.website" class="panel-body center">
          
        </div>
      </div>
    </div>
  </div>
  <div>
    <div class="col-md-6 col-offset-md-3">
      <div class="panel-heading">
        <h3 class="panel-title">
          Contact Form History - Coming Soon
        </h3>
      </div>
      <div *ngIf="dashboardService.website" class="panel-body center">
        
      </div>
    </div>
  </div>
</div>
